import { configure } from 'mobx';
import { TefComs4csMicroFrontend } from './components/tef-coms4cs';

// 22.04.2024 force rebuild

configure({
  isolateGlobalState: true,
});

window.customElements.define('tef-coms4cs', TefComs4csMicroFrontend);
